@import '../../../../style/src/typography/mixins';

:host {
	@include zds-typography('body');

	color: var(--zds-text-color-base);
	display: block;

	--zds-internal-input-search-transition: width 350ms var(--zds-transition-type-ease-shake), opacity 300ms linear;
}

:host([fit-height]) {
	height: 100%;
}

.zds-input-search {
	position: relative;

	&--collapsible {
		align-items: center;
		display: flex;

		.zds-input-search__input-icon {
			opacity: 0;
		}
	}

	&--fit-height {
		height: 100%;
	}

	.zds-input-search__input-wrapper {
		opacity: 1;
		pointer-events: inherit;
		width: 100%;

		&--collapsed {
			opacity: 0;
			pointer-events: none;
		}

		&--fit-height {
			height: 100%;
		}
	}

	.zds-input-search__icon {
		color: var(--zds-input-placeholder-color);
		left: -1px;
		pointer-events: none;
		position: absolute;
		transition:
			opacity var(--zds-transition-md),
			top 100ms var(--zds-transition-type-ease);

		&--collapsed {
			bottom: auto;
			pointer-events: inherit;
			top: 1px;
			transition:
				opacity var(--zds-transition-md),
				top 100ms var(--zds-transition-type-ease) 200ms;
		}
	}
}
